import 'antd/dist/antd.css';

import { Calendar, Form, Message, Select } from '@alifd/next';
import { Modal } from 'antd'; // dialog UI
import axios from 'axios';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';

import client from '../../../../lib/feathers';
import StarCell from './components/StarCell';
import styles from './index.module.scss';

const { Item } = Form;
const currentDate = moment();
const localeData = currentDate.clone().localeData();
const monthLocale = localeData.monthsShort();
const AnnualSchedule = (props) => {
  // console.log(props.uploadsProps)
  const clean = client.service('annualSchedule');
  const [categoryMenus, setCategoryMenus] = useState([]); // filter selector menu
  const [yearSelect, setYearSelect] = useState([]); // Calendar年 選擇

  const [cleanArrAll, setCleanArrAll] = useState([]); // Calendar All Data(全資料)
  const [cleanArr, setCleanArr] = useState([]); // Calendar render filtered Data(渲染資料)
  const [cleanCurrentArr, setCleanCurrentArr] = useState([]);
  const [previewDialog, setPreviewDialog] = useState(false);
  const [showDate, setShowDate] = useState(moment().add(0, 'days'));

  const [scheduleData, setScheduleData] = useState([]);
  // 查詢 clean
  function funFind(para) {
    return new Promise((resolve, reject) => {
      try {
        clean.find({ query: para }).then((result) => {
          resolve(result && result.data ? addCloneCalendar(result.data) : []);
          // resolve(result && result.data ? result.data : []);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  function addCloneCalendar(resD) {
    // DB formate to Ice Calendar formate & setCategory Arr
    const OutArr = [];
    const categoryArrs = ['全部'];
    let yearsArr = [new Date().getFullYear()];
    resD.forEach((e) => {
      e.showTimes.forEach((ee) => {
        if (e.category && !categoryArrs.includes(e.category))
          categoryArrs.push(e.category);
        if (e.targetYear && !yearsArr.includes(e.targetYear))
          yearsArr.push(e.targetYear);
        const outObj = {
          cleanTime: ee,
          name: e.name,
          contentText: e.name,
          category: e.category,
          isYear: !!e.hasOwnProperty('useMonths'),
          id: e._id,
        };

        OutArr.push(outObj);
      });
    });
    setCategoryMenus([...categoryArrs]);

    if (yearsArr.length === 1) yearsArr.push(yearsArr[0]);
    // 加入結束年限
    else {
      yearsArr = [yearsArr[0], yearsArr[yearsArr.length - 1]];
    }
    setYearSelect([...yearsArr]);
    return OutArr;
  }

  function ordersort(a, b) {
    return a.order < b.order ? 1 : -1;
  }
  // 刷新頁面
  function serverDataUpdate() {
    funFind({}).then((result) => {
      const rData = result.sort(ordersort);
      setCleanArrAll(result);
      setCleanArr(result);
    });
  }

  useEffect(() => {
    serverDataUpdate();
  }, [props.uploadsProps]);

  useEffect(() => {
    axios('/ezcon/api/equipmentCalendar', {
      method: 'GET',
      headers: {
        authorization: window.localStorage['feathers-jwt'],
      },
      // data: newRecord,
    })
      .then((res) => {
        console.log(res);
        setScheduleData(res.data);
      })
      .catch((err) => {
        console.log(err);
        Message.error(err);
      });
  }, []);

  const renderCell = useCallback(
    (type, time) => {
      const hasEvent = scheduleData.some(
        (data) =>
          moment(data.cleanTime).format(
            type === 'day' ? 'YY/MM/DD' : 'YY/MM'
          ) === moment(time).format(type === 'day' ? 'YY/MM/DD' : 'YY/MM')
      );
      return <StarCell hasEvent={hasEvent} time={time} type={type} />;
    },
    [scheduleData]
  );

  return (
    <>
      <Modal
        cancelText
        mask={false}
        className={styles.dialog}
        visible={previewDialog}
        onOk={() => {
          setPreviewDialog(false);
        }}
        onCancel={() => {
          setPreviewDialog(false);
        }}
        okText="關閉"
      >
        <Form>
          <h1>計畫表項目</h1>
          {cleanCurrentArr.map((list, index) => {
            return (
              <div key={index} className={styles.listContainer}>
                <div>
                  <Item label="計畫表日期">
                    <p>{new Date(list.cleanTime).toLocaleDateString()}</p>
                  </Item>
                  <Item label="計畫表項目">
                    <p>{list.name}</p>
                  </Item>
                  {/* <Item label="計畫表類型">
                    <p>{list.isYear ? '設備預約' : '公設預約'}</p>
                  </Item> */}
                  <Item label="計畫表類別">
                    <p>{list.category}</p>
                  </Item>
                </div>
              </div>
            );
          })}
        </Form>
      </Modal>
      {/* 日曆ＵＩ */}
      公設名稱：
      <Select dataSource={['健身房']}></Select>
      <Calendar
        // mode
        onSelect={(value) => {
          // console.log(new Date(value))
          const tarDialogDate = moment(value).format('YYYY/MM/DD');
          const filterRenderData = [...scheduleData].filter(
            (e) => moment(e.cleanTime).format('YYYY/MM/DD') === tarDialogDate
          );
          if (filterRenderData.length > 0) {
            setShowDate(moment(new Date(value).getTime()).add(0, 'days'));
            setCleanCurrentArr([...filterRenderData]);
            setPreviewDialog(true);
            Message.success('找尋資料成功');
          } else {
            Message.success('該天沒有資料!');
          }
        }}
        dateCellRender={(time) => renderCell('day', time)}
        monthCellRender={(time) => renderCell('month', time)}
        yearRange={[2021, new Date().getFullYear() + 1]}
        value={showDate}
      />
    </>
  );
};

export default AnnualSchedule;
